module.exports = __webpack_public_path__ + "static/media/icon-conlicitacao-gold.c3a379f4.svg";